import React from "react";
import {
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput,
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import IconEllipsis from "../Icon/Ellipsis.jsx";

class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // render each row details
  createRow = (row) => {
    let keys = Object.keys(row);

    return keys.map((key) => {
      return <td key={key}>{row[String(key)]}</td>;
    });
  };

  formatTime(dateString) {
    var date = new Date(dateString);
    return date.toLocaleDateString();
  }

  render() {
    const heads = this.props.heads;
    const dataAttributes = this.props.dataAttributes;
    const cols = heads.map((head) => (
      <th scope="col" key={head}>
        {head}
      </th>
    ));

    const rows = this.props.rows;
    const data = rows.map((row) => (
      <tr key={row.id}>
        <td key={`user-${row.id}-displayname`}>
          {row["category"] ? row["category"]["display_name"] : "訂閱推送"}
        </td>
        <td key={`user-${row.id}-title`}>{`${row["post"]["title"]}`}</td>
        <td className="ml-auto" style={{ maxWidth: "50px" }}>
          <UncontrolledDropdown>
            <DropdownToggle
              className="btn-icon-only text-light"
              href="#pablo"
              role="button"
              size="sm"
              color=""
              onClick={(e) => e.preventDefault()}
            >
              <IconEllipsis className="size-5" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.remove(row);
                }}
              >
                刪除
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));

    return (
      <OverlayLoading loading={this.props.loading}>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>{cols}</tr>
          </thead>
          <tbody>{data}</tbody>
        </Table>
      </OverlayLoading>
    );
  }
}

export default DataTable;
